import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import FormAlterarSenha from './FormAlterarSenha';
import { Row, Col } from '../../../node_modules/antd';

export class AlterarSenha extends Component {
  static propTypes = {
    acessoSistema: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    return (
      <div className="acesso-sistema-alterar-senha">
        <Row type="flex" justify="center" style={{ minHeight: '100vh' }} >
          <Col span={10} >
            <FormAlterarSenha history={this.props.history} />
          </Col>
        </Row>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    acessoSistema: state.acessoSistema,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AlterarSenha);



// WEBPACK FOOTER //
// ./src/features/acesso-sistema/AlterarSenha.js